import React from "react";
import { CardCvcElement, CardExpiryElement, CardNumberElement } from "@stripe/react-stripe-js";
import "./cardSection.scss";
import {
  StripeCardCvcElementChangeEvent,
  StripeCardExpiryElementChangeEvent,
  StripeCardNumberElementChangeEvent,
} from "@stripe/stripe-js";
import { useTranslation } from "react-i18next";

interface IProps {
  type: "one-row" | "two-row";
  onChange?: (
    e: StripeCardNumberElementChangeEvent | StripeCardExpiryElementChangeEvent | StripeCardCvcElementChangeEvent,
  ) => void;
}

function CardSection(props: IProps) {
  const { t } = useTranslation();
  if (props.type === "two-row") {
    return (
      <div className="">
        <div className="ui-card-number">
          <span className="font-medium text-gray-500 text-sm">{t("Card Number")}</span>
          <div className="stripe-element-container">
            <CardNumberElement
              onReady={ele => {
                ele.clear();
              }}
              onChange={e => props.onChange?.(e)}
              className=".StripeElement .StripeElement--focus .StripeElement--invalid .StripeElement--webkit-autofill"
            />
          </div>
        </div>
        <div className="flex gap-4 mt-2">
          <div className="w-full">
            <span className="font-medium text-gray-500 text-sm">{t("Expiry")}</span>
            <div className="stripe-element-container">
              <CardExpiryElement
                onReady={ele => {
                  ele.clear();
                }}
                onChange={e => props.onChange?.(e)}
                className=".StripeElement .StripeElement--focus .StripeElement--invalid .StripeElement--webkit-autofill"
              />
            </div>
          </div>
          <div className="w-full">
            <span className="font-medium text-gray-500 text-sm">{t("CVC")}</span>
            <div className="stripe-element-container">
              <CardCvcElement
                onReady={ele => {
                  ele.clear();
                }}
                onChange={e => props.onChange?.(e)}
                className=".StripeElement .StripeElement--focus .StripeElement--invalid .StripeElement--webkit-autofill"
              />
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="ui-credit-card">
        <div className="ui-credit-card_input ui-card-number_one-half">
          <span className="font-medium text-gray-500 text-sm">{t("Card Number")}</span>
          <div className="flex flex-1 border border-gray-500 rounded FormRow">
            <CardNumberElement
              onReady={ele => {
                ele.clear();
              }}
              onChange={e => props.onChange(e)}
              className="rounded w-full .StripeElement .StripeElement--focus .StripeElement--invalid .StripeElement--webkit-autofill"
            />
          </div>
        </div>
        <div className="ui-credit-card_input ui-card-number_one-quarter">
          <span className="font-medium text-gray-500 text-sm">{t("Expiry")}</span>
          <div className="border border-gray-500 rounded FormRow">
            <CardExpiryElement
              onReady={ele => {
                ele.clear();
              }}
              onChange={e => props.onChange(e)}
              className="w-full .StripeElement .StripeElement--focus .StripeElement--invalid .StripeElement--webkit-autofill"
            />
          </div>
        </div>
        <div className="ui-credit-card_input ui-card-number_one-quarter">
          <span className="font-medium text-gray-500 text-sm">{t("CVC")}</span>
          <div className="border border-gray-500 rounded FormRow">
            <CardCvcElement
              onReady={ele => {
                ele.clear();
              }}
              onChange={e => props.onChange(e)}
              className="w-full .StripeElement .StripeElement--focus .StripeElement--invalid .StripeElement--webkit-autofill"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CardSection;
